// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_59-0";